import React from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import BannerImage from "../../assets/images/hero-banner.png";
import PharmacyImage from "../../assets/images/pharmacy.png";
import MedDevicesImg from "../../assets/images/medical-devices.png";
import SuppliesImg from "../../assets/images/supplies-nonrx.jpg";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./index.module.css";
import { useNavigate } from "react-router-dom";
import Nav from "../../components/Nav";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import chatboticon from '../../assets/icons/Bck/chatboticon.png';
import PharmacyIconImg from "../../assets/icons/Bck/Group 18250.png";
import PhoneIconImg from "../../assets/icons/Bck/Group 18258.png";
import FaxIconImg from "../../assets/icons/Bck/Group 18257.png";
import TextIconImg from "../../assets/icons/Bck/Group 18256.png";
import SendIcon from "@mui/icons-material/Send";

function LandingPage() {
  const navigate = useNavigate();
  const [chatOpen, setChatOpen] = React.useState(false);
  const [messages, setMessages] = React.useState([]);
  const [input, setInput] = React.useState("");

  const handleSend = () => {
  if (!input.trim()) return;

  const newMessage = { text: input.trim(), sender: "user" };
  setMessages((prev) => [...prev, newMessage]);
  setInput("");

  setTimeout(() => {
    setMessages((prev) => [
      ...prev,
      { text: "Thanks for your message! We'll get back to you shortly.", sender: "bot" },
    ]);
  }, 1000);
};
  const InfoItem = ({ icon, title, value, showDivider }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        px: 1.5,
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: "8px",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          flexShrink: 0,
        }}
      >
        <Box component="img" src={icon} sx={{ width: 200 }} />
      </Box>
      <Box>
        <Typography variant="h6" sx={{ color: "#0a9a73", fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography
          variant="body1"
          color="text.primary"
          sx={{
            whiteSpace: { xs: "normal", md: "nowrap" },
            overflow: "hidden",
            textOverflow: { md: "ellipsis" },
            wordBreak: "break-word",
            overflowWrap: "anywhere",
          }}
          title={value}
        >
          {value}
        </Typography>
      </Box>
      {showDivider && (
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: "20%",
            height: "60%",
            width: "1px",
            backgroundColor: "#e0e0e0",
            display: { xs: "none", md: "block" },
          }}
        />
      )}
    </Box>
  );


  return (
    <Stack className={styles.landingPage} component="main" direction="column">
      <Stack className={styles.mainSection}>
        <Box className={styles.heroBanner}>
          <img src={BannerImage} alt="hero-banner" />
        </Box>
        <Box className={styles.content}>
          <Stack
            spacing={2}
            direction={{
              xs: "row",
              sm: "row",
            }}
            sx={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <TextField
              variant="outlined"
              size="small"
              sx={{
                height: "32px",
                "& .MuiOutlinedInput-root": {
                  height: "32px",
                  backgroundColor: "white",
                  borderRadius: 0,
                },
                "& .MuiInputBase-root": {
                  paddingRight: "2px",
                },
                "& .MuiInputBase-input": {
                  paddingRight: "32px",
                },
              }}
              placeholder="Search"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Stack color="primary" sx={{}}>
                      <SearchIcon
                        sx={{
                          backgroundColor: "#0a9a73",
                          color: "white",
                          padding: "2px",
                        }}
                      />
                    </Stack>
                  </InputAdornment>
                ),
              }}
            />
            <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
              <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  background: "white",
                  height: "30px",
                  borderRadius: "4px",
                  padding: "8px",
                  boxSizing: "border-box",
                }}
              >
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{ alignItems: "center" }}
                >
                  <Typography sx={{ lineHeight: 1 }} variant="overline">
                    EN
                  </Typography>
                  <ExpandMoreIcon sx={{ stroke: 0.5 }} />
                </Stack>
                <Divider sx={{ mx: "4px" }} orientation="vertical" />
                <Stack
                  direction="row"
                  spacing={0.5}
                  sx={{ alignItems: "center" }}
                >
                  <Typography sx={{ lineHeight: 1 }} variant="overline">
                    USD
                  </Typography>
                  <ExpandMoreIcon />
                </Stack>
              </Stack>
              <Button
                variant="contained"
                size="small"
                sx={{ display: { xs: "none", sm: "block" } }}
              >
                Login | Pay Bill
              </Button>
              <Tooltip title="Login | Pay Bill">
                <IconButton
                  variant="contained"
                  size="large"
                  sx={{ color: "white", display: { xs: "flex", sm: "none" } }}
                >
                  <AccountCircleIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
          <Nav />
          <Stack
            direction={{ xs: "column", lg: "row" }}
            spacing={{ xs: 6, lg: 2 }}
            sx={{ mt: "100px" }}
          >
             <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 3,
                justifyContent: { xs: 'center', sm: 'space-between' },
                alignItems: "stretch",
              }}
            >
            <Card
              sx={{
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "31%",
                  },
                  mb: 3,
                  opacity: 0.9,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
            >
              
              {/* <CardMedia
                component="img"
                sx={{ height: 250 }}
                src={MedDevicesImg}
                title="green iguana"
              /> */}
              <CardContent sx={{ padding: '25px', pb: 0}}>
                <Typography gutterBottom variant="h5" component="div">
                  Medical Supplies
                </Typography>
                <Typography gutterBottom variant="body1" component="div">
                  Enhancing your healthcare experience with advanced tools for
                  accurate diagnosis and effective treatment.
                </Typography>
              </CardContent>
              <CardActions sx={{ mt: "auto", mb: "20px", pl: '25px' }}>
                <Button
                  onClick={() => navigate("/medicalsupplies")}
                  size="small"
                  variant="contained"
                >
                  Learn More
                </Button>
              </CardActions>
            </Card>
            <Card
              sx={{
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "31%",
                  },
                  mb: 3,
                  opacity: 0.9,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
            >
              {/* <CardMedia
                component="img"
                sx={{ height: 250 }}
                src={PharmacyImage}
                title="green iguana"
              /> */}
              <CardContent sx={{ padding: '25px', pb: 0}}>
                <Typography gutterBottom variant="h5" component="div">
                  Pharmacy
                </Typography>
                <Typography gutterBottom variant="body1" component="div">
                  Your trusted source for quality medicines, healthcare
                  products, and expert advice.
                </Typography>
              </CardContent>
              <CardActions sx={{ mt: "auto", mb: "20px", pl: "25px" }}>
                <Button
                  onClick={() => navigate("/pharmacy")}
                  size="small"
                  variant="contained"
                >
                  Learn More
                </Button>
              </CardActions>
            </Card>
            <Card
              sx={{
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "31%",
                  },
                  mb: 3,
                  opacity: 0.9,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
            >
              {/* <CardMedia
                component="img"
                sx={{ height: 250 }}
                src={SuppliesImg}
                title="green iguana"
              /> */}
              <CardContent sx={{ padding: '25px', pb: 0}}>
                <Typography gutterBottom variant="h5" component="div">
                  Supplies (Non Rx)
                </Typography>
                <Typography gutterBottom variant="body1" component="div">
                  Trusted non-prescription supplies for your practice.
                  Affordable, compliant, and ready when you need them.
                </Typography>
              </CardContent>
              <CardActions sx={{ mt: "auto", mb: "20px", pl: '25px' }}>
                <Button
                  // onClick={() => navigate("/products")}
                  size="small"
                  variant="contained"
                >
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Box>
          </Stack>
        </Box>
      </Stack>
      <Box sx={{ background: "white", p: "2rem", pb: "1rem"}}>
        <Box className={styles.content} sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "stretch",
            justifyContent: "space-between",
            gap: 4,
          }}>
          
          <Box
              sx={{
                width: {
                  xs: "100%",
                  md: '50%'
                },
                background: "white",
                borderRadius: "8px",
                opacity: 0.95,
                p: 0,
                // boxShadow: 3,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                height: "100%",
              }}
            >
              <Box sx={{ p: "2rem" }}>
              <Typography
                sx={{
                  fontSize: "41px",
                  fontWeight: "600",
                  mb: 2,
                }}
              >
                Find the Best Products for Your Health
              </Typography>
              <Typography sx={{ fontSize: "19px", color: "#555"}}>
                An innovative platform designed to make it easier for you to
                find the best doctor to suit your health needs. With a user
                friendly interface and advanced search features.
              </Typography>
          </Box>
        </Box>
          
            <Box sx={{
              width: { xs: "100%", md: "50%" },
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
             }}
            >
             <CardMedia
              component="img"
              sx={{ 
                height: "80%",
                width: "100%",
                maxWidth: "380px",
                borderRadius: "8px",
                objectFit: "cover",
              }}
              src={MedDevicesImg}
              title="Medical Devices"
            />
          </Box>
        </Box>
      </Box>
      <Box className={styles.content} sx={{ minHeight: "100px" }}>
        <Box sx={{ py: 4, }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(4, 1fr)",
              },
              alignItems: "center",
              gap: 2,
            }}
          >
            <InfoItem
              icon={PharmacyIconImg}
              title="SavCare Pharmacy"
              value="15 Poyson Road, STE. 101, Foxboro, 02035 MA"
              showDivider
            />

            <InfoItem
              icon={PhoneIconImg}
              title="Telephone"
              value="774 765 1616"
              showDivider
            />

            <InfoItem
              icon={FaxIconImg}
              title="Fax"
              value="774 765 1617"
              showDivider
            />

            <InfoItem
              icon={TextIconImg}
              title="Text"
              value="774 228 7069"
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          width: "80px",
          height: "80px",
          backgroundColor: "#0a9a73",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
          zIndex: 1001,
          '&:hover': { transform: "scale(1.1)" },
        }}
        onClick={() => setChatOpen(!chatOpen)}
      >
        <img
          src={chatboticon}
          alt="ChatBot"
          style={{ width: 40, height: 40 }}
        />
      </Box>
      {chatOpen && (
        <Box
          sx={{
            position: "fixed",
            bottom: "120px",
            right: "30px",
            width: "350px",
            height: "500px",
            backgroundColor: "white",
            opacity:0.95,
            borderRadius: "10px",
            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid #ddd",
              backgroundColor: "#f5f5f5",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 600 }}
            >
              Hi, how can we help you?
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              p: 2,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {messages.map((msg, idx) => (
              <Box
                key={idx}
                sx={{
                  alignSelf: msg.sender === "user" ? "flex-end" : "flex-start",
                  backgroundColor: msg.sender === "user" ? "#e1f4ef" : "#f0f0f0",
                  color: msg.sender === "user" ? "#0a9a73" : "black",
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  maxWidth: "70%",
                  fontFamily: "Josefin Sans, sans-serif",
                }}
              >
                {msg.text}
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              p: 1,
              borderTop: "1px solid #ddd",
              display: "flex",
              gap: 1,
            }}
          >
            <TextField
              fullWidth
              size="small"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Enter..."
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSend();
              }}
              sx={{
                "& .MuiInputBase-root": {
                  borderRadius: 1,
                },
              }}
            />
            <IconButton
              onClick={handleSend}
              disabled={!input.trim()}
              sx={{
                backgroundColor: "#0a9a73",
                color: "white",
                width: 40,
                height: 40,
                borderRadius: "8px",
                "&.Mui-disabled": {
                  backgroundColor: "#cfe8df",
                  color: "#ffffff",
                },
                "&:hover": {
                  backgroundColor: "#088f68",
                },
              }}
            >
              <SendIcon />
            </IconButton>
          </Box>
        </Box>
      )}
    </Stack>
  );
}

LandingPage.propTypes = {};

export default LandingPage;
